import {useEffect} from 'react';
import {FeatureDemo} from '@Components/poster-editor/poster-editor.types';
import {useAppSelector} from '@/hooks';

export const useQRFeatureDemoPreselection = (): void => {
  const isWhiteboardInitialized = useAppSelector((state) => !!state.posterEditor.posterObject?.isInitialized);

  useEffect(() => {
    if (!isWhiteboardInitialized) {
      return;
    }

    const featureDemo = window.PMW.redux.store.getState().posterEditor.featureDemo;
    if (featureDemo !== FeatureDemo.QR_CODE) {
      return;
    }

    const page = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!page) {
      return;
    }

    for (const [, item] of Object.entries(page.items.itemsHashMap)) {
      if (item.isQRItem()) {
        page.activeSelection.selectFabricObjects([item.fabricObject]);
        break;
      }
    }
  }, [isWhiteboardInitialized]);
};
